export default __webpack_public_path__ + "static/media/lady2.810c6917.jpg";